var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8659 17.0041C13.7312 17.0036 13.5979 16.9759 13.4742 16.9226C13.3505 16.8693 13.2388 16.7916 13.1459 16.6941L9.28586 12.6941C9.10263 12.5072 9 12.2558 9 11.9941C9 11.7323 9.10263 11.481 9.28586 11.2941L13.2859 7.29409C13.3791 7.20085 13.4898 7.12689 13.6116 7.07643C13.7334 7.02597 13.864 7 13.9959 7C14.1277 7 14.2583 7.02597 14.3801 7.07643C14.5019 7.12689 14.6126 7.20085 14.7059 7.29409C14.7991 7.38733 14.8731 7.49802 14.9235 7.61984C14.974 7.74166 14.9999 7.87223 14.9999 8.00409C14.9999 8.13595 14.974 8.26652 14.9235 8.38834C14.8731 8.51016 14.7991 8.62085 14.7059 8.71409L11.4059 12.0041L14.5859 15.3041C14.7721 15.4915 14.8766 15.7449 14.8766 16.0091C14.8766 16.2733 14.7721 16.5267 14.5859 16.7141C14.4912 16.808 14.3788 16.882 14.2551 16.9318C14.1315 16.9816 13.9991 17.0062 13.8659 17.0041Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron_left.9b3078c5235d3205830d68dbca53dcdd.svg";
export { ForwardRef as ReactComponent };